import { api } from '../../../api/axios'
import type { RelatorioResponse } from '../types'

export const relatoriosService = {
  resultadoIndividual: (idinscricao: number) =>
    api.get<RelatorioResponse>('/relatorios/resultado-individual', { params: { idinscricao } }).then(r => r.data),

  rankingGeral: (idcampeonato: number, idmodalidade?: number) =>
    api.get<RelatorioResponse>('/relatorios/ranking-geral', {
      params: { idcampeonato, ...(idmodalidade ? { idmodalidade } : {}) },
    }).then(r => r.data),

  medalhas: (idcampeonato: number, top: number, idmodalidade?: number, idetapa?: number) =>
    api.get<RelatorioResponse>('/relatorios/medalhas', {
      params: { idcampeonato, top, ...(idmodalidade ? { idmodalidade } : {}), ...(idetapa ? { idetapa } : {}) },
    }).then(r => r.data),

  participantes: (idcampeonato: number, idmodalidade?: number) =>
    api.get<RelatorioResponse>('/relatorios/participantes', {
      params: { idcampeonato, ...(idmodalidade ? { idmodalidade } : {}) },
    }).then(r => r.data),

  whatsapp: (params: {
    tipo: 'resultado-individual' | 'ranking-geral' | 'medalhas'
    idinscricao?: number
    idcampeonato?: number
    idmodalidade?: number
    top?: number
  }) => api.post<RelatorioResponse>('/relatorios/resultado-individual/whatsapp', params).then(r => r.data),
}
